import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import useUniqueId from 'hooks/useUniqueId';
import Pill from 'components/Pill';
import InlineList from 'components/InlineList';
import Modal from 'components/Modal';
import FormField, { useFormFieldContext } from 'components/FormField';
import TopicSelector from 'screens/TopicSelector';
import AddOrEditButton from './AddOrEditButton';
function TopicList(_ref) {
  var onButtonClick = _ref.onButtonClick,
    topics = _ref.topics,
    variant = _ref.variant,
    isDisabled = _ref.isDisabled;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var hasSelectedTopics = !!topics.length;
  var _useFormFieldContext = useFormFieldContext(),
    labelId = _useFormFieldContext.labelId;
  return /*#__PURE__*/React.createElement(InlineList, {
    spacing: "xxs",
    "aria-labelledby": labelId,
    align: "middle"
  }, topics.map(function (topic) {
    return /*#__PURE__*/React.createElement(Pill, {
      key: topic.id,
      icon: "topic"
    }, topic.name);
  }), /*#__PURE__*/React.createElement(AddOrEditButton, {
    isEditMode: hasSelectedTopics,
    addText: t('actions_add_topics'),
    editText: t('actions_edit_topics'),
    variant: variant,
    onClick: onButtonClick,
    isDisabled: isDisabled
  }));
}
function TopicField(_ref2) {
  var id = _ref2.id,
    selectedTopics = _ref2.selectedTopics,
    onChange = _ref2.onChange,
    _ref2$horizontal = _ref2.horizontal,
    horizontal = _ref2$horizontal === void 0 ? true : _ref2$horizontal,
    _ref2$variant = _ref2.variant,
    variant = _ref2$variant === void 0 ? 'transparent' : _ref2$variant,
    isDisabled = _ref2.isDisabled;
  var _useTranslation2 = useTranslation(),
    t = _useTranslation2.t;
  var uniqueId = useUniqueId(id);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isTopicEditorModalOpen = _useState2[0],
    setTopicEditorModalOpen = _useState2[1];
  return /*#__PURE__*/React.createElement(FormField, {
    as: "span",
    label: t('content_type_topic_plural'),
    labelId: uniqueId,
    horizontal: horizontal
  }, /*#__PURE__*/React.createElement(TopicList, {
    variant: variant,
    topics: selectedTopics,
    onButtonClick: function onButtonClick() {
      return setTopicEditorModalOpen(true);
    },
    isDisabled: isDisabled
  }), isTopicEditorModalOpen && /*#__PURE__*/React.createElement(Modal, {
    id: "topic-editor-modal",
    "aria-label": t('actions_assign_topics'),
    onRequestClose: function onRequestClose() {
      return setTopicEditorModalOpen(false);
    }
  }, /*#__PURE__*/React.createElement(TopicSelector, {
    initialSelected: selectedTopics,
    onChangeSelectedTopics: onChange,
    onClose: function onClose() {
      return setTopicEditorModalOpen(false);
    }
  })));
}
export default TopicField;